import moment from "moment";
import { api_instance_auth } from ".";

export const uploadPriceComparisonFileAPI = async (body) => {
  const response = await api_instance_auth.post(
    "/upload-transactions-report",
    body
  );
  return response;
};

export const fetchPriceComparisonFileAPI = async ({
  page,
  limit,
  order,
  search,
  rangeStart,
  rangeEnd,
}) => {
  const start =
    moment(rangeStart).format("YYYY-MM-DD") === "Invalid date"
      ? ""
      : moment(rangeStart).format("YYYY-MM-DD");
  const end =
    moment(rangeEnd).format("YYYY-MM-DD") === "Invalid date"
      ? ""
      : moment(rangeEnd).format("YYYY-MM-DD");
  const response = await api_instance_auth.get(
    `/get-transactions-report?page=${page}&limit=${limit}&order=${order}&search=${search}&rangeStart=${start}&rangeEnd=${end}`
  );
  return response;
};

export const fetchComparisonData = async ({
  id,
  rangeStart,
  rangeEnd,
  signal,
}) => {
  if (id === null) {
    return null;
  }
  const start = rangeStart
    ? moment(rangeStart).format("YYYY-MM-DD") === "Invalid date"
      ? ""
      : moment(rangeStart).format("YYYY-MM-DD")
    : "";
  const end = rangeStart
    ? moment(rangeEnd).format("YYYY-MM-DD") === "Invalid date"
      ? ""
      : moment(rangeEnd).format("YYYY-MM-DD")
    : "";
  const response = await api_instance_auth.get(
    `/get-transactions-report-details/${id}?${start ? `&rangeStart=${start}` : ""
    }${end ? `&rangeEnd=${end}` : ""}`
  );
  return response;
};

export const compareResultData = async ({
  id,
  rangeStart,
  rangeEnd,
  signal,
}) => {
  const start =
    moment(rangeStart).format("YYYY-MM-DD") === "Invalid date"
      ? ""
      : moment(rangeStart).format("YYYY-MM-DD");
  const end =
    moment(rangeEnd).format("YYYY-MM-DD") === "Invalid date"
      ? ""
      : moment(rangeEnd).format("YYYY-MM-DD");
  const response = await api_instance_auth.get(
    `/compare-price/${id}?&rangeStart=${start || ""}&rangeEnd=${end || ""}`,
    {
      signal,
    }
  );
  return response;
};

export const updateCostPlusValue = async ({
  creditCostPlus,
  prepaidCostPlus,
  creditCostPlusLoves,
  prepaidCostPlusLoves,
  costPlus,
  distanceRadius,
  stateFallback,
  selectPetro
}) => {
  const settingsData = [];

  if (creditCostPlus) {
    settingsData.push({
      key: "credit_cost_plus",
      value: creditCostPlus,
    });
  }

  if (creditCostPlusLoves) {
    settingsData.push({
      key: "credit_cost_plus_loves",
      value: creditCostPlusLoves,
    });
  }

  if (prepaidCostPlusLoves) {
    settingsData.push({
      key: "prepay_cost_plus_loves",
      value: prepaidCostPlusLoves,
    });
  }

  if (prepaidCostPlus) {
    settingsData.push({
      key: "prepay_cost_plus",
      value: prepaidCostPlus,
    });
  }
  if (costPlus) {
    settingsData.push({
      key: "cost_plus",
      value: costPlus,
    });
  }
  if (distanceRadius) {
    settingsData.push({
      key: "distance_radius",
      value: distanceRadius,
    });
  }
  if (stateFallback) {
    settingsData.push({
      key: "state_fallback",
      value: stateFallback,
    });
  }
  if (selectPetro) {
    settingsData.push({
      key: "station",
      value: selectPetro,
    });
  }
  const response = await api_instance_auth.patch(`/update-settings`, {
    settingsData: settingsData,
  });
  return response;
};
export const ViewStationsComparisonAPI = async ({
  id,
  page,
  limit,
  order,
  search,
  rangeStart,
  rangeEnd,
}) => {
  const start =
    moment(rangeStart).format("YYYY-MM-DD") === "Invalid date"
      ? ""
      : moment(rangeStart).format("YYYY-MM-DD");
  const end =
    moment(rangeEnd).format("YYYY-MM-DD") === "Invalid date"
      ? ""
      : moment(rangeEnd).format("YYYY-MM-DD");
  const response = await api_instance_auth.get(
    `/view-stations-comparison/${id}?page=${page}&limit=${limit}&sortOrder=${order}&search=${search}&rangeStart=${start}&rangeEnd=${end}&sortColumn=transaction_date`
  );
  return response;
};
